import { useTranslation } from 'react-i18next';

import { InfoGrayIcon } from 'assets';
import { usePalletsTypes } from 'constants/palletTypes';

import styles from './OrderTerms.module.css';

const OrderTerms = () => {
   const { t } = useTranslation();

   const { palletTypesData } = usePalletsTypes();

   return (
      <div className={styles.container}>
         <div className={styles.header}>
            <InfoGrayIcon />
            <h3>{t('orderTerms.title')}</h3>
         </div>
         <table className={styles.table}>
            <thead>
               <tr>
                  <th>{t('damaged_by_client.table.pallet_type')}</th>
                  <th>{t('palletConfigurationCard.logisticMinimum')}</th>
               </tr>
            </thead>
            <tbody>
               {palletTypesData.map((palletType, index) => (
                  <tr key={index}>
                     <td>{palletType.label + ' ' + palletType.dimensions}</td>
                     <td>
                        {palletType.logisticMinimum}
                        {palletType.logisticMinimumUpperRange &&
                           ' do ' + palletType.logisticMinimumUpperRange}{' '}
                        {t('common.pallets')}
                     </td>
                  </tr>
               ))}
            </tbody>
         </table>
      </div>
   );
};

export default OrderTerms;
